import gql from "graphql-tag";

export const VERIFY_EMAIL = gql`
  mutation MyMutation($email: String!, $verifyEmailToken: String!) {
    verifyEmail(email: $email, verifyEmailToken: $verifyEmailToken) {
      affected_rows
    }
  }
`;
